module.exports = __webpack_public_path__ + "fonts/IBM_Plex_Sans-300-1.a17fb86.woff2";